import { render, staticRenderFns } from "./merge-contact-selector-fields.vue?vue&type=template&id=7e8f5338&scoped=true&"
import script from "./merge-contact-selector-fields.vue?vue&type=script&lang=ts&"
export * from "./merge-contact-selector-fields.vue?vue&type=script&lang=ts&"
import style0 from "./merge-contact-selector-fields.vue?vue&type=style&index=0&id=7e8f5338&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8f5338",
  null
  
)

export default component.exports